const redefinePublicPath = () => {
  // We don't support setting public path in webpack via NPM build.
};

export { redefinePublicPath };
//# sourceMappingURL=public-path.mjs.map
